module.exports = __webpack_public_path__ + "img/tsg_serve.e0301905.png";